import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpRefreshTokenInterceptor } from './http-refresh-token.interceptor';

export const httpRefreshTokenInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpRefreshTokenInterceptor, multi: true },
];
